import { useAnalyticsTags } from '@libs/analytics';
import { useOptimizely } from '@libs/common-next';

import type { AssistedSearchState } from '../search.types';
import { trackApplicationSubmit as trackApplicationSubmitEffects } from './track-application-submit';

type TrackApplicationSubmitOptions = {
    assistedSearch: AssistedSearchState;
    query: string;
};

export function useSearchAnalytics() {
    const { context: optimizelyContext } = useOptimizely();
    const currentAnalyticsTags = useAnalyticsTags(['autocomplete']);
    const trackApplicationSubmit = ({ assistedSearch, query }: TrackApplicationSubmitOptions) => {
        trackApplicationSubmitEffects({
            assistedSearch,
            query,
            trackOptimizelySearch: optimizelyContext ? () => optimizelyContext.trackEvent('user_search') : undefined,
        });
    };

    return { currentAnalyticsTags, trackApplicationSubmit };
}
